(function($){

    if ($("body").is(".soubor-zobrazit_detail")) {

        $(document).scroll(function () {
            if ($(this).scrollTop() >= $('.why-love').offset().top) {
                $(".c-produkt-detail__fixed").addClass("position-fixed");
            } else {
                $(".c-produkt-detail__fixed").removeClass("position-fixed");
            }
        });
    }

})(jQuery);
